/**
 * Inflationskonstanten und -daten für die 3-Topf vs. 1-Topf Portfolio Monte-Carlo Simulation Anwendung
 * Historische Inflationsdaten und zugehörige Hilfsfunktionen
 */

import {
  BaseStatistics,
  StatisticalCalculationService,
} from '../services/StatisticalCalculationService';

// Historische Inflationsdaten (1914-2024)
export const INFLATIONSDATEN = {
  2024: { germany: 2.4, usa: 2.89 },
  2023: { germany: 6.0, usa: 3.35 },
  2022: { germany: 8.7, usa: 6.45 },
  2021: { germany: 3.2, usa: 7.04 },
  2020: { germany: 0.4, usa: 1.36 },
  2019: { germany: 1.4, usa: 2.29 },
  2018: { germany: 1.9, usa: 1.91 },
  2017: { germany: 1.7, usa: 2.11 },
  2016: { germany: 0.4, usa: 2.07 },
  2015: { germany: 0.7, usa: 0.73 },
  2014: { germany: 0.8, usa: 0.76 },
  2013: { germany: 1.6, usa: 1.5 },
  2012: { germany: 2.2, usa: 1.74 },
  2011: { germany: 2.5, usa: 2.96 },
  2010: { germany: 1.1, usa: 1.5 },
  2009: { germany: 0.2, usa: 2.72 },
  2008: { germany: 2.8, usa: 0.09 },
  2007: { germany: 2.3, usa: 4.08 },
  2006: { germany: 1.8, usa: 2.54 },
  2005: { germany: 1.9, usa: 3.42 },
  2004: { germany: 1.8, usa: 3.26 },
  2003: { germany: 1.1, usa: 1.88 },
  2002: { germany: 1.3, usa: 2.38 },
  2001: { germany: 1.9, usa: 1.55 },
  2000: { germany: 1.4, usa: 3.39 },
  1999: { germany: 0.6, usa: 2.68 },
  1998: { germany: 0.6, usa: 1.61 },
  1997: { germany: 1.5, usa: 1.7 },
  1996: { germany: 1.3, usa: 3.32 },
  1995: { germany: 1.7, usa: 2.54 },
  1994: { germany: 2.7, usa: 2.67 },
  1993: { germany: 4.5, usa: 2.75 },
  1992: { germany: 5.0, usa: 2.9 },
  1991: { germany: 3.5, usa: 3.06 },
  1990: { germany: 2.7, usa: 6.11 },
  1989: { germany: 2.8, usa: 4.65 },
  1988: { germany: 1.3, usa: 4.42 },
  1987: { germany: 0.2, usa: 4.43 },
  1986: { germany: -0.1, usa: 1.1 },
  1985: { germany: 2.1, usa: 3.8 },
  1984: { germany: 2.4, usa: 3.95 },
  1983: { germany: 3.3, usa: 3.79 },
  1982: { germany: 5.3, usa: 3.83 },
  1981: { germany: 6.3, usa: 8.92 },
  1980: { germany: 5.4, usa: 12.52 },
  1979: { germany: 4.04, usa: 13.29 },
  1978: { germany: 2.72, usa: 9.02 },
  1977: { germany: 3.73, usa: 6.7 },
  1976: { germany: 4.255, usa: 4.86 },
  1975: { germany: 5.91, usa: 6.94 },
  1974: { germany: 6.99, usa: 12.34 },
  1973: { germany: 7.03, usa: 8.71 },
  1972: { germany: 5.48, usa: 3.41 },
  1971: { germany: 5.24, usa: 3.27 },
  1970: { germany: 3.45, usa: 5.57 },
  1969: { germany: 1.917, usa: 6.2 },
  1968: { germany: 1.47, usa: 4.72 },
  1967: { germany: 1.8, usa: 3.04 },
  1966: { germany: 3.53, usa: 3.46 },
  1965: { germany: 3.24, usa: 1.92 },
  1964: { germany: 2.342, usa: 0.97 },
  1963: { germany: 2.972, usa: 1.64 },
  1962: { germany: 2.84, usa: 1.33 },
  1961: { germany: 2.29, usa: 0.67 },
  1960: { germany: 1.54, usa: 1.36 },
  1959: { germany: 0.6, usa: 1.73 },
  1958: { germany: 2.3, usa: 1.76 },
  1957: { germany: 2.0, usa: 2.9 },
  1956: { germany: 2.8, usa: 2.99 },
  1955: { germany: 1.4, usa: 0.37 },
  1954: { germany: 0.4, usa: -0.74 },
  1953: { germany: -1.7, usa: 0.75 },
  1952: { germany: 2.1, usa: 0.75 },
  1951: { germany: 7.8, usa: 6.0 },
  1950: { germany: null, usa: 5.93 },
  1949: { germany: null, usa: -2.07 },
  1948: { germany: null, usa: 2.99 },
  1947: { germany: null, usa: 8.84 },
  1946: { germany: null, usa: 18.13 },
  1945: { germany: null, usa: 2.25 },
  1944: { germany: null, usa: 2.3 },
  1943: { germany: null, usa: 2.96 },
  1942: { germany: null, usa: 9.03 },
  1941: { germany: null, usa: 9.93 },
  1940: { germany: null, usa: 0.71 },
  1939: { germany: null, usa: 0.0 },
  1938: { germany: null, usa: -2.78 },
  1937: { germany: null, usa: 2.86 },
  1936: { germany: null, usa: 1.45 },
  1935: { germany: null, usa: 2.99 },
  1934: { germany: null, usa: 1.52 },
  1933: { germany: null, usa: 0.76 },
  1932: { germany: null, usa: -10.27 },
  1931: { germany: null, usa: -9.32 },
  1930: { germany: null, usa: -6.4 },
  1929: { germany: null, usa: 0.58 },
  1928: { germany: null, usa: -1.16 },
  1927: { germany: null, usa: -2.26 },
  1926: { germany: null, usa: -1.12 },
  1925: { germany: null, usa: 3.47 },
  1924: { germany: null, usa: 0.0 },
  1923: { germany: null, usa: 2.37 },
  1922: { germany: null, usa: -2.31 },
  1921: { germany: null, usa: -10.82 },
  1920: { germany: null, usa: 2.65 },
  1919: { germany: null, usa: 14.55 },
  1918: { germany: null, usa: 20.44 },
  1917: { germany: null, usa: 18.1 },
  1916: { germany: null, usa: 12.62 },
  1915: { germany: null, usa: 1.98 },
  1914: { germany: null, usa: 1.0 },
} as const;

// Historische Tagesgeld-Zinssätze Deutschland (2008-2025) in Prozent
export const TAGESGELD_ZINSSAETZE = {
  2025: { germany: 1.92, usa: null },
  2024: { germany: 2.51, usa: null },
  2023: { germany: 1.63, usa: null },
  2022: { germany: 0.1, usa: null },
  2021: { germany: 0.01, usa: null },
  2020: { germany: 0.01, usa: null },
  2019: { germany: 0.32, usa: null },
  2018: { germany: 0.43, usa: null },
  2017: { germany: 0.35, usa: null },
  2016: { germany: 0.34, usa: null },
  2015: { germany: 0.58, usa: null },
  2014: { germany: 0.88, usa: null },
  2013: { germany: 1.02, usa: null },
  2012: { germany: 1.54, usa: null },
  2011: { germany: 1.85, usa: null },
  2010: { germany: 1.01, usa: null },
  2009: { germany: 1.25, usa: null },
  2008: { germany: 3.45, usa: null },
} as const;

// Zinstopf Performance (historische Anleihen-Renditen Deutschland 1967-2017) in Prozent
export const ZINSTOPF_PERFORMANCE = {
  2017: { germany: 0.45, usa: null },
  2016: { germany: 0.1, usa: null },
  2015: { germany: 0.63, usa: null },
  2014: { germany: 1.16, usa: null },
  2013: { germany: 1.57, usa: null },
  2012: { germany: 1.5, usa: null },
  2011: { germany: 2.61, usa: null },
  2010: { germany: 2.74, usa: null },
  2009: { germany: 3.22, usa: null },
  2008: { germany: 3.98, usa: null },
  2007: { germany: 4.22, usa: null },
  2006: { germany: 3.76, usa: null },
  2005: { germany: 3.35, usa: null },
  2004: { germany: 4.04, usa: null },
  2003: { germany: 4.07, usa: null },
  2002: { germany: 4.78, usa: null },
  2001: { germany: 4.8, usa: null },
  2000: { germany: 5.26, usa: null },
  1999: { germany: 4.5, usa: null },
  1998: { germany: 4.57, usa: null },
  1997: { germany: 5.64, usa: null },
  1996: { germany: 6.23, usa: null },
  1995: { germany: 6.86, usa: null },
  1994: { germany: 6.88, usa: null },
  1993: { germany: 6.49, usa: null },
  1992: { germany: 7.89, usa: null },
  1991: { germany: 8.61, usa: null },
  1990: { germany: 8.88, usa: null },
  1989: { germany: 6.94, usa: null },
  1988: { germany: 6.1, usa: null },
  1987: { germany: 5.93, usa: null },
  1986: { germany: 5.92, usa: null },
  1985: { germany: 6.87, usa: null },
  1984: { germany: 7.78, usa: null },
  1983: { germany: 7.89, usa: null },
  1982: { germany: 8.99, usa: null },
  1981: { germany: 10.38, usa: null },
  1980: { germany: 8.5, usa: null },
  1979: { germany: 7.4, usa: null },
  1978: { germany: 5.74, usa: null },
  1977: { germany: 6.21, usa: null },
  1976: { germany: 7.79, usa: null },
  1975: { germany: 8.48, usa: null },
  1974: { germany: 10.41, usa: null },
  1973: { germany: 8.89, usa: null },
  1972: { germany: 7.21, usa: null },
  1971: { germany: 7.32, usa: null },
  1970: { germany: 8.39, usa: null },
  1969: { germany: 7.08, usa: null },
  1968: { germany: 6.27, usa: null },
  1967: { germany: 6.65, usa: null },
} as const;

// Hilfsfunktionen für Inflationsdaten
export const getInflationRate = (
  year: number,
  region: 'germany' | 'usa' = 'germany'
): number | null => {
  const data = INFLATIONSDATEN[year as keyof typeof INFLATIONSDATEN];
  return data ? data[region] : null;
};

export const getAverageInflationRate = (
  startYear: number,
  endYear: number,
  region: 'germany' | 'usa' = 'germany'
): number | null => {
  const rates = [];
  for (let year = startYear; year <= endYear; year++) {
    const rate = getInflationRate(year, region);
    if (rate !== null) {
      rates.push(rate);
    }
  }

  if (rates.length === 0) {return null;}

  return rates.reduce((sum, rate) => sum + rate, 0) / rates.length;
};

export const getInflationYears = (): number[] => {
  return Object.keys(INFLATIONSDATEN)
    .map(year => parseInt(year))
    .sort((a, b) => b - a);
};

// Hilfsfunktionen für Tagesgeld-Daten
export const getTagesgeldRate = (
  year: number,
  region: 'germany' | 'usa' = 'germany'
): number | null => {
  const data = TAGESGELD_ZINSSAETZE[year as keyof typeof TAGESGELD_ZINSSAETZE];
  return data ? data[region] : null;
};

export const getAverageTagesgeldRate = (
  startYear: number,
  endYear: number,
  region: 'germany' | 'usa' = 'germany'
): number | null => {
  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    const rate = getTagesgeldRate(year, region);
    if (rate !== null) {
      years.push(rate);
    }
  }

  if (years.length === 0) {return null;}

  return years.reduce((sum, rate) => sum + rate, 0) / years.length;
};

export const getTagesgeldYears = (): number[] => {
  return Object.keys(TAGESGELD_ZINSSAETZE)
    .map(year => parseInt(year))
    .sort((a, b) => b - a);
};

// Hilfsfunktionen für Zinstopf-Daten
export const getZinstopfPerformance = (
  year: number,
  region: 'germany' | 'usa' = 'germany'
): number | null => {
  const data = ZINSTOPF_PERFORMANCE[year as keyof typeof ZINSTOPF_PERFORMANCE];
  return data ? data[region] : null;
};

export const getAverageZinstopfPerformance = (
  startYear: number,
  endYear: number,
  region: 'germany' | 'usa' = 'germany'
): number | null => {
  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    const performance = getZinstopfPerformance(year, region);
    if (performance !== null) {
      years.push(performance);
    }
  }

  if (years.length === 0) {return null;}

  return years.reduce((sum, performance) => sum + performance, 0) / years.length;
};

export const getZinstopfYears = (): number[] => {
  return Object.keys(ZINSTOPF_PERFORMANCE)
    .map(year => parseInt(year))
    .sort((a, b) => b - a);
};

// German inflation statistics (1914-2024)
export interface InflationStatistics extends BaseStatistics {}

export const getGermanInflationStatistics = (): InflationStatistics => {
  return StatisticalCalculationService.calculateInflationStatistics(INFLATIONSDATEN);
};

// Tagesgeld statistics (2008-2025)
export interface TagesgeldStatistics extends BaseStatistics {}

export const getGermanTagesgeldStatistics = (): TagesgeldStatistics => {
  return StatisticalCalculationService.calculateTagesgeldStatistics(TAGESGELD_ZINSSAETZE);
};

// Zinstopf statistics (1967-2017)
export interface ZinstopfStatistics extends Omit<BaseStatistics, 'rates' | 'dataTable'> {
  performances: number[];
  dataTable: Array<{ year: number; performance: number }>;
}

export const getGermanZinstopfStatistics = (): ZinstopfStatistics => {
  const baseStats = StatisticalCalculationService.calculateZinstopfStatistics(ZINSTOPF_PERFORMANCE);
  return {
    ...baseStats,
    performances: baseStats.rates,
    dataTable: baseStats.dataTable.map(item => ({ year: item.year, performance: item.rate })),
  };
};
